import { render, staticRenderFns } from "./DemoPaginationCircle.vue?vue&type=template&id=54cfe432&"
import script from "./DemoPaginationCircle.vue?vue&type=script&lang=js&"
export * from "./DemoPaginationCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
